<template>
  <container-loader v-if="!loaded"></container-loader>
  <div v-else>
    <h4 class="highlight underline">{{ info.filename }}</h4>
    <b-row>
      <b-col :cols="hasPreview ? 7 : null">
        <b-row v-for="item in infoRows" v-bind:key="item.name" class="underline m-0 items-parent">
          <b-col class="text--600 pl-0 flex-grow-0 text-nowrap">{{ item.name }}</b-col>
          <b-col class="text--gray text-right pr-0">{{ item.value }}</b-col>
        </b-row>
      </b-col>
      <b-col v-if="hasPreview" cols="5">
        <b-img :src="previewSrc" class="w-100"/>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'
  import Modal from '@/mixins/modal';
  import Gcode from '@/mixins/gcode';

  export default {
    name: "file-gcode-info",
    mixins: [Modal, Gcode],
    props: {fileId : {type: [Number, String], required: true}},
    data () {
      return{
        loaded: false,
        infoRows: [],
        info: {}
      }
    },
    computed: {
      hasPreview() {
        return this.info.picture && this.info.picture.trim() !== '';
      },
      previewSrc() {
        return window.as3Url + 'render/' + this.info.picture;
      },
    },
    methods: {
      ...mapActions(['getImprintaGcodeInfo']),
    },
    created() {
      this.getImprintaGcodeInfo({fileId: this.fileId, full: true}).then(({data}) => {
        this.loaded = true;
        if (!data.result) {
          this.toast(this.$t('fileGcodeInfo.errorGetInfo', {msg: data.message}));
        } else {
          this.info = data.message;
          this.infoRows = this.getGcodeInfoArray(data.message);
        }
      });
    }
  }
</script>

<style scoped>
  .underline {
    border-bottom: 1px solid rgba(195, 210, 218, 0.4);
  }
  h4 {
    padding: 15px 0 20px 0;
    margin-bottom: 20px;
  }
  .text--gray {
    color: #575757;
  }
  .items-parent {
    padding: 2px 0;
  }
</style>
